import { isSelfHostedDistribution } from "utils/distribution";
import { AccountContext } from "views/AccountWrapper";

import useSelfHostedFlags from "./useSelfHostedFlags";
import useTypedContext from "./useTypedContext";
import useTypedFlags from "./useTypedFlags";

const isSelfHosted = isSelfHostedDistribution();

/**
 * Whether the Flows access-as-code surface (projects list + role management) is enabled for the
 * current account. Admin-only, and gated separately from the legacy Flows settings page so we can
 * roll it out independently.
 * SaaS reads the flag from LaunchDarkly, self-hosted from the backend evaluated flags.
 */
const useIsFlowsAacIntegrationEnabled = (): boolean => {
  const { flowsAacIntegration } = useTypedFlags();
  const { flowsAacIntegration: flowsAacIntegrationSelfHosted } = useSelfHostedFlags();
  const { viewer } = useTypedContext(AccountContext);

  return (isSelfHosted ? flowsAacIntegrationSelfHosted : flowsAacIntegration) && viewer.admin;
};

export default useIsFlowsAacIntegrationEnabled;
